import * as React from "react";
import FooterBase from "@vorne/gatsby-theme-marketing/components/footer/footer";
import footerItems from "./footerItems";

const Footer = () => {
  return <FooterBase email="info@oee.com" items={footerItems} />;
};

export default Footer;
